import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const ParticipantTestimonials = () => {
  return <section className="mb-12" data-id="element-275">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-276">
        Wat deelnemers ervaren tijdens het webinar
      </h2>

      <div className="space-y-6" data-id="element-277">
        <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-278">
          <div className="flex items-start gap-4" data-id="element-279">
            <img src="https://cdn.magicpatterns.com/uploads/fB8Dhs4wiGrDqogWAqXKm6/Scherm_afbeelding_2025-08-15_om_15.51.14.png" alt="Lenneke uit Utrecht" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-280" />
            <div data-id="element-281">
              <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-282" />
              <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-283">
                "Na 20 minuten begreep ik al waarom onze wandelingen altijd
                chaotisch waren. Luna probeerde me de hele tijd te vertellen dat
                ze zich onveilig voelde, maar ik interpreteerde het als
                koppigheid. Het moment dat ik dat doorhad, veranderde alles."
              </p>
              <p className="text-sm font-semibold text-gray-700" data-id="element-284">
                - Lenneke uit Utrecht
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-285">
          <div className="flex items-start gap-4" data-id="element-286">
            <img src="https://cdn.magicpatterns.com/uploads/pS516JjYb2Jy2Jib3WaRmC/Scherm­afbeelding_2026-04-07_om_17.13.16.png" alt="Thomas uit Antwerpen" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-287" />
            <div data-id="element-288">
              <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-289" />
              <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-290">
                "Mijn vrouw en ik keken elkaar halverwege het webinar aan.
                'Daarom doet hij dat!' zeiden we tegelijk. Plotseling maakten
                alle rare gewoontes van Rex perfect zin."
              </p>
              <p className="text-sm font-semibold text-gray-700" data-id="element-291">
                - Thomas uit Antwerpen
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 border-l-4 border-green-500 p-5 rounded-r-lg" data-id="element-292">
          <div className="flex items-start gap-4" data-id="element-293">
            <img src="https://cdn.magicpatterns.com/uploads/cq9sJtJYFgjvYc8NrDV2AV/Scherm­afbeelding_2026-04-07_om_17.14.25.png" alt="Sandra uit Amsterdam" className="w-14 h-14 rounded-full object-cover flex-shrink-0" data-id="element-294" />
            <div data-id="element-295">
              <QuoteIcon className="w-6 h-6 text-green-400 mb-2" data-id="element-296" />
              <p className="text-gray-800 leading-relaxed italic mb-3" data-id="element-297">
                "Het was emotioneel. Ik realiseerde me dat Buddy mij al maanden
                probeerde iets te vertellen over zijn angst, en ik dacht maar
                dat hij ongehoorzaam was. Ik voelde me schuldig, maar ook
                opgelucht. Eindelijk begreep ik hem."
              </p>
              <p className="text-sm font-semibold text-gray-700" data-id="element-298">
                - Sandra uit Amsterdam
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};